import React, {Component} from "react";
import { render } from 'react-dom';
import { Modal, Button,Label} from 'react-bootstrap';
//import firebase from 'firebase'
import {auth, firebase} from '../firebase';

class ModalFood extends Component {

  constructor(props) {
   super(props);

  this.handleShow = this.handleShow.bind(this);
  this.handleClose = this.handleClose.bind(this);
  this.mainOptionExtras = this.mainOptionExtras.bind(this);
  this.incOrder = this.incOrder.bind(this);
  this.decOrder = this.decOrder.bind(this);
  this.addToCart = this.addToCart.bind(this);

   this.state = {

     show: false,
     count : 1,
     total:0,
     enableButton : false,
     options:[],
     extras:[],
     element_extras:[],
     main_option_extras:[],
     main_option : [{},{extras : {}}],
     selected_main_element:[],
     price_option:[],
     element_extras_price:[],
     price_extras:0,
     ancien:{
      products_count:0,
      total_price:0,
      items:{}
    }



   /*  
     order : 1,
     total : 0,
     idSlectedOptions : [],
     extras:{},
    
     numberSlectedOptions : 0,*/

   };

 }

 componentDidMount(){
  var user=JSON.parse(localStorage.getItem('user'))
   if(user){
  var ref= firebase.database().ref(`/users_carts/${user.uid}/${this.props.id}`);

  ref.on("value",(data)=>{
    if(data.val()!==null)
    this.setState({ancien:data.val()})
    else
    this.setState({ancien:{products_count:0,total_price:0,items:{}}})

  })

   this.setState({total : this.props.food[1].price});
   var main_option = this.state.main_option;
   main_option[0] = this.props.food[1].main_option_id;
   this.setState({main_option :main_option});
   if(this.props.food[1].options){
    this.setState({enableButton :true});
   }

  }
 }



 addToCart(e){
   this.handleClose();
   this.props.addToCart(e);
 }
//close modal
 handleClose() {
   this.setState({  show: false,
    count : 1,
    total:0,
    enableButton : false,
    options:[],
    extras:[],
    element_extras:[],
    main_option_extras:[],
    main_option : [{},{extras : {}}],
    selected_main_element:[],
    price_option:[],
    element_extras_price:[],
    price_extras:0
  
  
  });
 }
//show modal
 handleShow() {
  this.setState({ show: true });
 }
// inc quantity
 incOrder() {
  this.setState({ count: this.state.count+1 });
 }
// dec quantity
 decOrder() {
  if(this.state.count>1){
    this.setState({ count: this.state.count-1 });
  }
 }
//
calcul_total(){
var price=this.props.food[1].price
var quantity=this.state.count
var element_extras_price=this.state.element_extras_price
var price_option=this.state.price_option
var price_extras=this.state.price_extras
var options =this.state.options
var total=0;
var total_option_price =0;

Object.keys(options||[]).forEach((v,e) => {
  var element=Object.keys(options[v].elements)[0];

  total_option_price=total_option_price+options[v].elements[element].price+(element_extras_price[element]?element_extras_price[element]:0);
  
});

total=(total_option_price+price_extras+price)*quantity

return total

}
calcul_extras_price(e,price){
  if(e.target.checked)
  {
    this.setState((prevState)=>{return {price_extras:
      (prevState.price_extras+price)
    }

    })

  }
  else{
    this.setState((prevState)=>{return {price_extras:
      (prevState.price_extras-price)
    }

    })
  }

}




calcul_element_extras_price(id,e,price){

  if(e.target.checked)
  {
    this.setState((prevState)=>{return {element_extras_price:{[id]:
      ((prevState.element_extras_price[id]?prevState.element_extras_price[id]:0)+price)}
    }

    })

  }
  else{
    this.setState((prevState)=>{return {element_extras_price:{[id]:
      (prevState.element_extras_price[id]-price)}
    }

    })
  }


}
set_extras(e,name,price,id){
  if(e.target.checked)
  {
    this.setState({extras:{...this.state.extras,[id]:{name:name,price:price}}})

  }
  else{
    this.setState({extras:{...this.state.extras,[id]:null}})

  }

}
set_element_extras(e,name,price,id,element){
/*console.log(e.target.checked)
console.log(name)
console.log(price)
console.log(id[0])
console.log(element)*/

if(e.target.checked)
{
  this.setState({element_extras:{[element]:{...this.state.element_extras[element],[id[0]]:{name:name,price:price}}}})

}
else{
  this.setState({element_extras:{[element]:{...this.state.element_extras[element],[id[0]]:null}}})

}

}

set_options(e,element,isMAin,option){
 /* console.log(e)
  console.log(option[0])
  console.log(option[1].name)
  console.log(element[0])

  console.log(element[1].name)
  console.log(isMAin)*/
this.setState({options:{...this.state.options,[option[0]]:{name:option[1].name,elements:{[element[0]]:{name:element[1].name,price:element[1].price}}}}})



}






 mainOptionExtras(event, element) {
   //console.log(element)
   //console.log(event)

   if(element[1].extras){
    this.setState({main_option : [this.props.food[1].main_option_id,{extras : element[1].extras}, element[0]]});
    this.changePrice(event,element[1].price);
   }
   else{
    this.setState({main_option : [this.props.food[1].main_option_id,{extras : {}},element[0]]});
    this.changePrice(event,element[1].price);
  }
 }

 saveCart(){
var user=JSON.parse(localStorage.getItem('user'))
   
   var ref= firebase.database().ref(`/users_carts/${user.uid}/${this.props.id}`);
   var key=ref.push().key
   var price=this.calcul_total()
   var quantity=this.state.count

   ref.update(
     {products_count:this.state.count+this.state.ancien.products_count,
    total_price:price+this.state.ancien.total_price,
    items:{...this.state.ancien.items,[key]:{extras:{...this.state.extras,...(this.state.element_extras[this.state.selected_main_element]?this.state.element_extras[this.state.selected_main_element]:{})},
    options:this.state.options,
    item_price:price/quantity,
    quantity:this.state.count,
    total_item_price:price,
    variant:{
      name:this.props.food[1].name,
      category_id:this.props.food[1].category_id,
      product_id:this.props.food[0],
      sub_category_id:this.props.food[1].sub_category_id,
      price:this.props.food[1].price,
      discount_price:this.props.food[1].discount_price,
      main_image	:this.props.food[1].main_image?this.props.food[1].main_image:null	,
      updated_at:this.props.food[1].updated_at,



    }

  }

  }}


   ).then(()=>{
    this.handleClose()
   })

 }
 
 /*changePrice(event, price, idoption){
  if(event.target.type === "checkbox" ){
   // console.log()
    this.setState({extras:{...this.state.extras,[event.target.value]:{cheked:event.target.checked,name:event.target.name}}})
    if(idoption === this.state.main_option[0]) {
      var list = [];
      list = this.state.idSlectedOptions;
      if(event.target.checked){
        if(list[idoption] && list[idoption].id == event.target.name){
          list[idoption].extras = list[idoption].extras || 0;
          list[idoption].extras = list[idoption].extras + price;
         // alert('1')
          
        }
        
        this.setState({total : this.state.total+price});
      }
      else {
        if(list[idoption] && list[idoption].id == event.target.name){
          list[idoption].extras = list[idoption].extras || 0;
          list[idoption].extras = list[idoption].extras - price;
        }
       // alert('2')
        this.setState({total : this.state.total-price});
      }
      
      this.setState ({idSlectedOptions : list});
    }
    else {
      if(event.target.checked) {
      this.setState({total : this.state.total+price});
      }
      else {
        this.setState({total : this.state.total-price});
      }
    }
  }

  else if(event.target.type === "radio"){
     var option = event.target;
     var list = [];
     list = this.state.idSlectedOptions;
     if(list[option.name]){
      if(list[option.name].id != option.value){
        var totalExtras=list[option.name].extras || 0;
        var total = this.state.total - list[option.name].price - totalExtras + price;
        this.setState({total : total});
        list[option.name] =  {id : option.value, price : price,name:option.name};
        this.setState ({idSlectedOptions : list});
      }
    }
    else {
      this.setState({numberSlectedOptions : this.state.numberSlectedOptions + 1}, () => {
        if(this.state.numberSlectedOptions == Object.entries(this.props.food[1].options).length) {
          this.setState({enableButton : false});
        }
      });
      list[option.name] = {id : option.value, price : price,name:option.name};
      this.setState({total : this.state.total+price});
      this.setState ({idSlectedOptions : list});
    }
  }
 }*/
 changePrice(event, price, idoption,e){
   //console.log(event.target.checked)
   //console.log(price)
   
   //console.log(idoption)
   //console.log(e)


 }


 elementChange(e,element,isMAin,option){
   /*console.log(e)
   console.log(option[0])
   console.log(option[1].name)
   console.log(element[0])
   console.log(element[1].name)
   console.log(isMAin)*/

   if(isMAin){
     this.setState({selected_main_element:element[0]})
   }

 }

  render() {

   var enabledB=(Object.entries(this.props.food[1].options||[]).length===Object.keys(this.state.options||[]).length) 
  // console.log(this.props) 
    var extra;
    var listElementsExtra;
    var supplement;
    var main_option_id=this.props.food[1].main_option_id
    var options_extras=[]
    if(main_option_id)
    options_extras=this.props.food[1].options[main_option_id].elements
     //console.log(options_extras)
     //console.log(this.props.food[1].extras)
     //console.log(this.state )
     //console.log(this.calcul_total())
    // 
    if(this.props.food[1].extras && Object.entries(this.props.food[1].extras).length>0) {
      extra = <h5 style={{fontFamily:'Arial',marginBottom:10}} className = "titleExtras">EXTRAS</h5>
    }
    if(this.props.food[1].main_option_id) {
      supplement  = <h5 style={{fontFamily:'Arial',marginBottom:10}} className = "titleExtras">SUPPLEMENTS</h5>
    }


///extras list **** ////////

    const listExtras = this.props.food[1].extras ? Object.entries(this.props.food[1].extras).map((extra, index) =>
      <div className="food-item white" key={index}>
        <div className="row">
          <div className="col-xs-6 col-sm-2 col-lg-2">
            <div className="rest-descr">
              <input style={{fontFamily:'Arial'}} type="checkbox" name="extras" value={extra[0]} onClick={(e) =>{ this.changePrice(e, extra[1].price,extra[0])
              this.set_extras(e,extra[1].name,extra[1].price,extra[0])
              this.calcul_extras_price(e,extra[1].price)
              }
              
              } />
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 col-lg-6">
            <div className="rest-descr">
              <h5 style={{fontFamily:'Arial'}}><a to="#">{extra[1].name}</a></h5>
            </div>
          </div>
          {/* end:col */}
          <div className="col-xs-6 col-sm-2 col-lg-2 text-xs-center"> <span className="price pull-left">{extra[1].price} {this.props.currency}</span></div>
          <div className="col-xs-6 col-sm-4 col-lg-4">
          </div>
        </div>
        {/* end:row */}
      </div>
    ) : null;

    if((listExtras||[]).length>0)
    listExtras.push(<hr/>)
////////////////////// ***** //////////////



//////option List **** ///////////////////////
    const listOptions = this.props.food[1].options ? Object.entries(this.props.food[1].options).map((option, index) =>
    {
    let isMAin=(option[0]===main_option_id)
    
return<div className="food-item white" key = {index}>
<h5 className="titleExtras" style={{fontFamily:'Arial',marginBottom:10}}>{option[1].name.toUpperCase()}<Label className="requiredOption" style={{float:'right', fontFamily:'Arial',color:'#ffffff',backgroundColor:'red'}}>OBLIGATOIRE</Label></h5>
{listElements(option,this.props.currency,isMAin)}
<hr/>
</div>
    }
       
 
    
    ) : null;
//////////***** //////////////////     


var listElementsExtras=[]
///// element extras 
//console.log(this.state.selected_main_element)
if(this.state.selected_main_element.length>0 && options_extras[this.state.selected_main_element]!==undefined && options_extras[this.state.selected_main_element]!==null)
    var listElementsExtras = Object.entries(options_extras[this.state.selected_main_element].extras||[]).map((extra, index) =>
      <div className="row" key = {index}>
        <div className="col-xs-6 col-sm-2 col-lg-2">
          <div className="rest-descr">
            <input type="checkbox" checked={(this.state.element_extras[this.state.selected_main_element])?(this.state.element_extras[this.state.selected_main_element][extra[0]])?true:false:false} name={this.state.main_option[2] } value={extra[0]} onClick = {(e) =>{ 
              this.changePrice(e, extra[1].price,this.state.main_option[0],extra)
            this.set_element_extras(e, extra[1].name, extra[1].price,extra,this.state.selected_main_element)
            this.calcul_element_extras_price(this.state.selected_main_element,e,extra[1].price)
            }}/>
          </div>
        </div>
        <div className="col-xs-12 col-sm-6 col-lg-6">
          <div className="rest-descr">
            <h5 style={{fontFamily:'Georgia'}}><a to="#">{extra[1].name}</a></h5>
          </div>
        </div>
        {/* end:col */}
        <div className="col-xs-6 col-sm-2 col-lg-2 text-xs-center"> <span className="price pull-left" >{extra[1].price} {this.props.currency}</span></div>
      </div>
    );
    if((listElementsExtras||[]).length>0)
    listElementsExtras.push(<hr/>)
//console.log(listElementsExtras)
const that = this;
  function listElements(option,currency,isMAin) {
    if(option[1].elements){
      return Object.entries(option[1].elements).map((element, index) =>
        <div className="row" key={index}>
          <div className="col-xs-6 col-sm-2 col-lg-2">
            <div className="rest-descr">
              <input type="radio" name={option[0]} value={element[0]} onClick = {(e) => {that.mainOptionExtras(e,element)
              that.elementChange(e,element,isMAin,option)
              that.set_options(e,element,isMAin,option)
            }
              }/>
            </div>
          </div>
          <div className="col-xs-12 col-sm-6 col-lg-6">
            <div className="rest-descr">
              <h5 style={{fontFamily:'Georgia'}}><a to="#">{element[1].name}</a></h5>
            </div>
          </div>

          {/* end:col */}
          <div className="col-xs-6 col-sm-2 col-lg-2 text-xs-center"> <span className="price pull-left">{element[1].price} {currency}</span>
          </div>
        </div>
      );
    }
  }
 /* console.log(listOptions)
  console.log(supplement)
  console.log(listElementsExtras)
  console.log(extra)
  console.log(listExtras)
  console.log(this.props.food)*/

    return (
      <Modal show={this.state.show} onHide={this.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title id= "titleFood">
            {this.props.food[1].name}
            <div id="divCountOrder" style={{float:'right'}}>
              <i style={{marginRight:10}} className="fa fa-minus-square countIcon" aria-hidden="true" onClick = {this.decOrder}></i>
              {this.state.count}
              <i  style={{marginLeft:10,marginRight:20}}className="fa fa-plus-square countIcon" aria-hidden="true" onClick = {this.incOrder}></i>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{marginLeft:25,marginRight:25}}>
          {listOptions}
        
          {supplement}
         
          {listElementsExtras}
          
          {extra}
        
          {listExtras}
        </Modal.Body>
        <Modal.Footer>
          <Label style={{fontFamily:"sans-serif",float:'left',fontSize:17,color:"#ffffff",backgroundColor:"#ffad18"}}  id="total">{this.calcul_total().toFixed(3)}        {this.props.currency}</Label>
          <Button className="btn theme-btn" id ="addCart" disabled = {!enabledB} onClick= {()=>this.saveCart()}>Ajouter au panier</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ModalFood;



// WEBPACK FOOTER //
// ./src/container/ModalFood.jsx